<template>
  <div class="progress-bar width100 mt12" >
      <div class="progress-bar-active" :style="{width: getActivePercent+'%'}"></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  computed: {
    getActivePercent(){
        return this.percent;
    }
  },
  props:{
      percent:{ required: true, default: 0 }
  }
 
};
</script>
